import { Card, CardBody, CardHeader, ScrollShadow } from '@nextui-org/react';
import Image from 'next/image';

import { EmptyState } from '@/components/ui/empty-state/empty-state';

import type { UploadedFile } from '@/shared/types/types';

interface UploadedFilesCardProps {
  uploadedFiles: UploadedFile[];
}

export function UploadedFilesCard({ uploadedFiles }: UploadedFilesCardProps) {
  return (
    <Card>
      <CardHeader>Uploaded files</CardHeader>
      <CardBody>
        {uploadedFiles.length > 0 ? (
          <ScrollShadow className="pb-4">
            <div className="flex w-max space-x-2.5">
              {uploadedFiles.map((file) => {
                return (
                  <div key={file.key} className="relative aspect-video w-64">
                    <Image
                      src={file.url}
                      alt={file.name}
                      fill
                      sizes="(min-width: 640px) 640px, 100vw"
                      loading="lazy"
                      className="rounded-md object-cover"
                    />
                  </div>
                );
              })}
            </div>
          </ScrollShadow>
        ) : (
          <EmptyState
            title="No files uploaded"
            description="Upload some files to see them here"
          />
        )}
      </CardBody>
    </Card>
  );
}
